import { PhoneFilled } from "@ant-design/icons";

import "./audio-player.styles.scss";

const AudioPlayer = ({ label, base64EncodedAudio }) => (
  <div className="audio-player">
    <div className="icon-container">
      <PhoneFilled className="icon" />
    </div>
    <div className="label">{label}</div>
    <audio src={base64EncodedAudio} controls />
  </div>
);

export default AudioPlayer;
